import { ATTRIBUTE_CONDITION_TYPE } from './attribute-condition';

/**
 * The dryad condition-type ids the people-search surface uses. Values are the
 * shared condition-type vocabulary (they appear in analytics payloads and
 * builder state, never on the filters wire itself).
 */
export const ConditionType = {
  DeviceAttribute: 'device_attribute',
  Event: 'event',
  Message: 'message',
  NewsletterRecipients: 'newsletter_recipients',
  OptOut: 'opt_out',
  SegmentsNegatable: 'segments_negatable',
} as const;

export type PeopleSearchConditionType =
  | typeof ATTRIBUTE_CONDITION_TYPE
  | (typeof ConditionType)[keyof typeof ConditionType];

/**
 * The people-search condition types the builder has rows for. The host
 * component mounting the builder intersects this with the workspace-gated
 * type list (no device conditions without push enabled, opt_out only with a
 * configured SMS/WhatsApp sender). Declared in the order the add menu sorts
 * to (alphabetical by its add-button label).
 */
export const PEOPLE_SEARCH_ROW_CONDITION_TYPES: PeopleSearchConditionType[] = [
  ATTRIBUTE_CONDITION_TYPE,
  ConditionType.DeviceAttribute,
  ConditionType.Event,
  ConditionType.Message,
  ConditionType.NewsletterRecipients,
  ConditionType.OptOut,
  ConditionType.SegmentsNegatable,
];

/** The row condition type a menu value names, or null for anything else. */
export function peopleSearchConditionTypeOf(value: string): PeopleSearchConditionType | null {
  return PEOPLE_SEARCH_ROW_CONDITION_TYPES.find((type) => type === value) ?? null;
}

export const PEOPLE_SEARCH_TYPE_LABELS = new Map<string, string>([
  [ATTRIBUTE_CONDITION_TYPE, 'Attribute'],
  [ConditionType.DeviceAttribute, 'Device'],
  [ConditionType.Event, 'Event'],
  [ConditionType.Message, 'Message'],
  [ConditionType.NewsletterRecipients, 'Newsletter'],
  [ConditionType.OptOut, 'Phone number'],
  [ConditionType.SegmentsNegatable, 'Segment'],
]);
